// OrderItem.js
import React,{useState} from "react";
import { useNavigate } from "react-router-dom";

const ClientOrder = ({ order}) => {
  const navigate = useNavigate();

  const handleShowOrder = () => {
      // Handle confirmation logic
      navigate(`/admin/commandes/commande/${order.id}`);
    };

  const buttonStyle = {
    backgroundColor: "#4CAF50",
    color: "white",
    cursor: "pointer",
  };

  return (
    <div key={order.id} className="order-item border p-4 mb-4 flex flex-col items-start shadow-lg rounded-lg bg-blueGray-100 border-0">
      <h3 className="text-lg font-bold mb-2">{order.username} {" :"} {order.id}{"-"}{order.user_id} </h3>
      <p>Email: {order.email}</p>
      <p>Telephone: {order.mobile}</p>
      <p>Type: {order.type}</p>
      <p>Date: {order.date}</p>
      <button
        className="bg-blue-500 text-white px-4 py-2 mt-2 rounded"
        onClick={handleShowOrder}
        style={{ backgroundColor: "#14939C" }}
      >
        Afficher les détails 
      </button>
    <br/>
    </div>
  );
};

export default ClientOrder;
